export const FETCH_EXAMS_FOR_STUDENT_PENDING = 'FETCH_EXAMS_FOR_STUDENT_PENDING'
export const FETCH_EXAMS_FOR_STUDENT_FULFILLED = 'FETCH_EXAMS_FOR_STUDENT_FULFILLED'
export const FETCH_EXAMS_FOR_STUDENT_REJECTED = 'FETCH_EXAMS_FOR_STUDENT_REJECTED'

export const SUBMIT_REFUND_EXAMS_PENDING = 'SUBMIT_REFUND_EXAMS_PENDING'
export const SUBMIT_REFUND_EXAMS_FULFILLED = 'SUBMIT_REFUND_EXAMS_FULFILLED'
export const SUBMIT_REFUND_EXAMS_REJECTED = 'SUBMIT_REFUND_EXAMS_REJECTED'

export const RESET_REFUND_EXAMS_FLOW = 'RESET_REFUND_EXAMS_FLOW'

export const FETCH_REFUNDED_EXAMS_PENDING = 'FETCH_REFUNDED_EXAMS_PENDING'
export const FETCH_REFUNDED_EXAMS_FULFILLED = 'FETCH_REFUNDED_EXAMS_FULFILLED'
export const FETCH_REFUNDED_EXAMS_REJECTED = 'FETCH_REFUNDED_EXAMS_REJECTED'

export const ORG_SEARCH_FORM_NAME = 'refundOrgSearch'
export const ORG_SEARCH_FIELD_NAME = 'refundOrgName'
export const ORG_SEARCH_FIELD_ID = 'refundOrgId'

export const STUDENT_SEARCH_FORM_NAME = 'refundStudentSearch'
export const STUDENT_SEARCH_FIELD_NAME = 'refundStudentName'
export const STUDENT_SEARCH_FIELD_ID = 'refundStudentId'

export const EXAM_SEARCH_FORM_NAME = 'refundExamSearch'
export const EXAM_SEARCH_FIELD_NAME = 'refundExam'
